import React from 'react';
import styled from 'styled-components';
import type { Card as CardModel } from '../types';
import { Card } from './Card';
import { Balance } from './Balance';
import { StatusChip } from './StatusChip';

/**
 * Desktop grid tile (PRD §3 / §5): the card face plus its own balance and
 * status chip beneath, wrapped in the white rounded "top-part" box (SEB-1612).
 * Tiles wrap (`CardSection` gaps) at a fixed 364px basis (316px card art +
 * 2×24px padding). Grow is 0 so a row with fewer tiles keeps them the same size
 * as a full row instead of stretching to fill the width; shrink stays on as a
 * narrow-container safety.
 */
const Tile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 0 1 364px;
  padding: 24px 24px 16px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const BalanceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CardTile: React.FC<{
  card: CardModel;
  onNavigate: (route: string) => void;
}> = ({ card, onNavigate }) => (
  <Tile>
    <Card card={card} onNavigate={onNavigate} />
    <BalanceRow>
      <Balance card={card} />
      <StatusChip status={card.status} />
    </BalanceRow>
  </Tile>
);
